import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import authService from "../services/auth.service";
import toast from "react-hot-toast";
import tradeService from "../services/trade.service";

export const useDeleteTrade = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { mutate: deleteTrade, isPending: isDeleting } = useMutation({
    mutationFn: tradeService.deleteTrade,
    onSuccess: () => {
      toast.success("Trade Deleted successfully");
      queryClient.invalidateQueries({
        queryKey: ["trades"],
      });
      navigate("/trade-journal/all-trades");
    },
    onError: (err) => {
      toast.error("Something went wrong");
    },
  });

  const { mutate: deleteAllTrades, isPending: isDeletingAll } = useMutation({
    mutationFn: tradeService.deleteTradeJournal,
    onSuccess: () => {
      toast.success("Trade Deleted successfully");
      queryClient.invalidateQueries({
        queryKey: ["trades"],
      });
    },
    onError: (err) => {
      toast.error("Something went wrong");
    },
  });

  return { deleteTrade, isDeleting, deleteAllTrades, isDeletingAll };
};
